import React, { useState , useEffect } from "react";
import "./Modal.css";

const Modal = ({ isOpen, onClose, postData }) => {
  const [expandedPosts, setExpandedPosts] = useState({}); // track expanded posts

  useEffect(() => {
    if(!isOpen){
      setExpandedPosts({});
    }
  },[isOpen]);
  
  if (!isOpen || !postData) return null;

  // Group posts by title
  const groupedPosts = postData.posts.reduce((acc, p) => {
    if (!acc[p.Posts]) acc[p.Posts] = [];
    acc[p.Posts].push(p);
    return acc;
  }, {});

  const toggleExpand = (title) => {
    setExpandedPosts((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✖</button>

        <h2 className="modal-title">Post Details - {postData.date}</h2>

        <div className="table-view-container">
          <table className="table-view">
            <thead>
              <tr>
                <th>Title</th>
                <th>Views</th>
                <th>Clicks</th>
                <th>Reach</th>
                <th>ROAS</th>
                <th>Transactions</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(groupedPosts).map(([title, channels], index) => {
                // Aggregate metrics for main row
                const agg = channels.reduce(
                  (acc, c) => {
                    acc.Views += c.Views || 0;
                    acc.Clicks += c.Clicks || 0;
                    acc.Reach += c.Reach || 0;
                    acc.Transactions += c.Transactions || 0;
                    acc.ROAS += c.ROAS || 0;
                    return acc;
                  },
                  { Views: 0, Clicks: 0, Reach: 0, Transactions: 0, ROAS: 0 }
                );

                return (
                  <React.Fragment key={index}>
                    {/* Main post row */}
                    <tr onClick={() => toggleExpand(title)} style={{ cursor: "pointer" }}>
                      <td>{title}</td>
                      <td>{agg.Views}</td>
                      <td>{agg.Clicks}</td>
                      <td>{agg.Reach}</td>
                      <td>{(agg.ROAS / channels.length).toFixed(2)}</td>
                      <td>{agg.Transactions}</td>
                    </tr>

                    {/* Expanded channel rows */}
                    {expandedPosts[title] &&
                      channels.map((cPost, cIndex) => (
                        <tr key={cIndex + "_sub"} className="channel-row">
                          <td style={{ paddingLeft: "20px" }}>↳ {cPost.Channel}</td>
                          <td>{cPost.Views}</td>
                          <td>{cPost.Clicks}</td>
                          <td>{cPost.Reach}</td>
                          <td>{cPost.ROAS}</td>
                          <td>{cPost.Transactions}</td>
                        </tr>
                      ))}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Modal;


